<div class="wrapper">
  <div class="headerWrapper">
    <h2>Модели</h2>
    <mat-form-field appearance="standard">
      <mat-label>Фильтр</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Фильтр" #input />
    </mat-form-field>
    <div class="carInfoWrapper">
      <h2>{{ manufacturer?.description }}</h2>
      <a routerLink="/manufacturer/list" mat-icon-button color="warn">
        <mat-icon>remove</mat-icon>
      </a>
    </div>
    <button mat-mini-fab color="primary" (click)="add()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="tableWrapper">
    <table mat-table [dataSource]="modelListFiltered">
      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td
          mat-cell
          *matCellDef="let model"
          class="select"
          [routerLink]="['/model/profile', model.id]"
        >
          {{ model.id }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Название</th>
        <td
          mat-cell
          *matCellDef="let model"
          class="select"
          [routerLink]="['/modification/list', model.id]"
        >
          {{ model.description }}
        </td>
      </ng-container>
      <ng-container matColumnDef="body">
        <th mat-header-cell *matHeaderCellDef>Кузов</th>
        <td mat-cell *matCellDef="let model">{{ model.body }}</td>
      </ng-container>
      <ng-container matColumnDef="date_from">
        <th mat-header-cell *matHeaderCellDef>Начало производства</th>
        <td mat-cell *matCellDef="let model">
          {{ model.manufacture_date_from.toLocaleDateString() }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date_to">
        <th mat-header-cell *matHeaderCellDef>Конец производства</th>
        <td mat-cell *matCellDef="let model">
          {{ model.manufacture_date_to?.toLocaleDateString() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">Не могу ничего найти :(</td>
      </tr>
    </table>
  </div>
</div>
